module.exports = __webpack_public_path__ + "static/img/5718af77081fa77b61155ed0445af5c.a02793f7.jpg";